import { Flex, VFlex } from '@/components/base';
import ProgressBar from '@/components/Chart/ProgressBar/ProgressBar';
import Spinner from '@/components/Common/Spinner';
import Typo from '@/components/Typography/Typo';
import { PREDICTION_STATE } from '@/types/taxonomyConst';

import predictionStateUtils from './utils';

const PredictionStateDisplay = (props: PredictionProgressPayload) => {
  const message = predictionStateUtils.getPredictionMessage(props);

  switch (props.prediction_state) {
    case PREDICTION_STATE.IDLE:
      return null;
    case PREDICTION_STATE.WAITING:
    case PREDICTION_STATE.RULE_CLASSIFICATION:
      return (
        <Flex a="center" g={12}>
          <Typo type="label2" weight="r" className="text-primary-100">
            {message}
          </Typo>
          <Spinner />
        </Flex>
      );
    default:
      return (
        <VFlex g={12}>
          <Flex a="center" g={12}>
            <Typo type="label2" weight="r" className="text-primary-100">
              {message}
            </Typo>
            <Spinner />
          </Flex>
          <Flex g={6}>
            <ProgressBar
              total={100}
              current={(props.progress_rate || 0) * 100}
              {...progressBarStyle}
            />
          </Flex>
        </VFlex>
      );
  }
};

const progressBarStyle = {
  style: { width: 400 },
  barStyle: { height: 8 },
};

export default PredictionStateDisplay;
